import React, { useState } from 'react'
import './ChatMessage.css'
import { HighFive, Player } from '../types'
import GetInspiredDialog from './GetInspiredDialog'

interface ChatMessageProps {
  highFive: HighFive
  player: Player
}

export const ChatMessage: React.FC<ChatMessageProps> = ({highFive, player}) => {
  const {senderId, date, message, videoFileName} = highFive
  const [isPlayingVideo, setIsPlayingVideo] = useState(false)
  
  const thumbnailSrcPrefix = `https://ik.imagekit.io/habitsgame/`
  const thumbnailSrc = `${thumbnailSrcPrefix}/${videoFileName}/ik-thumbnail.jpg`

  const formattedTimestamp = date.fromNow(true)
  const formattedTimestampWithSuffix = `${formattedTimestamp} ago`

  const handleClick = () => {
    if (videoFileName && !isPlayingVideo) {
      setIsPlayingVideo(true)
    }
  }

  return (
    <div className="ChatMessage" onClick={handleClick}>
      <div className="ChatMessage--chatBubble">
        {
          videoFileName ?
            <div className="ChatMessage--thumbnailContainer">
              <img
                src={thumbnailSrc}
                alt="Video Thumbnail"
                className="ChatMessage--thumbnailImage"
              />
              <div className='ChatMessage--thumbnailNote'>
                Tap to play video
              </div>
            </div>
          :
            <div>{message}</div>
        }
      </div>
      <div className="ChatMessage--messageTimestamp">
        Sent by {senderId === player.id ? "you" : highFive.senderFirstName}
        <div>{formattedTimestampWithSuffix}</div>
      </div>
      {
        isPlayingVideo && videoFileName &&
          <GetInspiredDialog
            videoFileName={videoFileName}
            onCancel={() => setIsPlayingVideo(false)}
          />
      }
    </div>
  )
}